import React, { createContext, useContext, useState, ReactNode } from "react"

export type PropertySearchStats = {
  totalProperties: number
  withLatestAlfredoData: number
  availableWithFilters: number
  isPropertyPipelineMode: boolean
}

type PropertySearchStatsContextType = { stats: PropertySearchStats | null; setStats: (stats: PropertySearchStats | null) => void }

const PropertySearchStatsContext = createContext<PropertySearchStatsContextType | undefined>(undefined)

type PropertySearchStatsProviderProps = { children: ReactNode }

export function PropertySearchStatsProvider({ children }: PropertySearchStatsProviderProps) {
  const [stats, setStats] = useState<PropertySearchStats | null>(null)

  return <PropertySearchStatsContext.Provider value={{ stats, setStats }}>{children}</PropertySearchStatsContext.Provider>
}

export const usePropertySearchStats = (): PropertySearchStatsContextType => {
  const context = useContext(PropertySearchStatsContext)
  // Return default values if context is not available (shouldn't happen, but safe fallback)
  if (!context) {
    return { stats: null, setStats: () => {} }
  }
  return context
}
